export const whiteBackgroundPlugin = {
    id: "ai_chart_white_background",
    beforeDraw: (chart) => {
        const { ctx } = chart;
        ctx.save();
        ctx.globalCompositeOperation = "destination-over";
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
    }
};

export function downloadCanvasPng(chart, title = "chart") {
    const canvas = chart?.canvas;
    if (!canvas) return;
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png", 1.0);
    link.download = `${title.replace(/\s+/g, "_")}.png`;
    link.click();
}
